<template>
  <div class="container-calendar">
    <div class="container-nav">
      <DayPilotNavigator id="nav" :config="navigatorConfig" ref="navigator" />
      <div class="violation-container-header">
        <button class="btn-filter" :class="{ 'btn-filter-selected': filterMode === 'errors' }"
          @click="filterViolations('errors')">Nur
          Fehler anzeigen
        </button>
        <button class="btn-filter" :class="{ 'btn-filter-selected': filterMode === 'all' }"
          @click="filterViolations('all')">Alle
          anzeigen
        </button>
      </div>
      <div class="violation-container" v-if="allViolations.length > 0">
        <div class="violation-container-loop" v-for="(entry, index) in allViolations" :key="index">
          <div class="event-violation" :class="{
            'event-violation-info': this.itemEventViolationInfo.includes(entry.violationAsString),
            'event-violation-warning': this.itemEventViolationWarning.includes(entry.violationAsString),
            'event-violation-error': this.itemEventViolationError.includes(entry.violationAsString)
          }" v-if="entry.type == 'item'" @click="goToEventWeek(entry.start)">
            <div class="event-violation-message">
              <svg class="event-violation-message" xmlns="http://www.w3.org/2000/svg" height="1rem" width="1rem" viewBox="0 0 512 512">
                <path class="event-violation-message" fill="#fff"
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
              </svg>
            </div>
            <div class="event-violation-message" :title="getViolationMessage(entry.violationAsString).desc">
              <p class="event-violation-date">{{ beautifulDate(entry.start) }},
                {{ beautifulTime(entry.start) }} - {{ beautifulTime(entry.end) }}</p>
              <p class="event-violation-title">{{ entry.issueSummary }}</p>
              <p class="event-violation-message">{{ getViolationMessage(entry.violationAsString).title }}</p>
            </div>
          </div>
          <div class="event-violation" :class="{
            'event-violation-info': this.dayEventViolationInfo.includes(entry.violationAsString),
            'event-violation-warning': this.dayEventViolationWarning.includes(entry.violationAsString),
            'event-violation-error': this.dayEventViolationError.includes(entry.violationAsString)
          }" v-if="entry.type == 'day'" @click="goToEventWeek(entry.start)">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg" height="1rem" width="1rem" viewBox="0 0 512 512">
                <path fill="#fff"
                  d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" />
              </svg>
            </div>
            <div :title="getViolationMessage(entry.violationAsString).desc">
              <p class="event-violation-date">{{ beautifulDate(entry.start) }}</p>
              <p class="event-violation-title">Tagesarbeitszeit</p>
              <p class="event-violation-message">{{ getViolationMessage(entry.violationAsString).title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="tab-viewtype">
        <button class="tab-link" @click="switchView('Day')">Tag</button>
        <button class="tab-link" @click="switchView('Week')">Woche</button>
        <div class="tab-total"> Summe: {{ toHoursAndMinutes(total) }}</div>
      </div>
      <DayPilotCalendar id="dp" :config="config" ref="calendar"></DayPilotCalendar>
    </div>
  </div>

</template>
<script>

import { DayPilot, DayPilotCalendar, DayPilotNavigator } from '@daypilot/daypilot-lite-vue';
import apiService from '@/service';
import { ColorHelper } from '@/colorHelper.js'

export default {
  name: 'CalendarComponent',
  data: function () {
    return {
      itemEventViolationInfo: ['BreakIsTooShort', 'BreakNotInValidTimeFrameButAlreadyValidPause'],
      itemEventViolationWarning: ['WorkDuringNightTime'],
      itemEventViolationError: ['BreakNotInValidTimeFrame'],
      dayEventViolationInfo: ['AverageWorkDayLongerThan8H'],
      dayEventViolationWarning: ['WorkOnSundayOrHoliday', 'WorkDayLongerThan10H', 'DailyRestTimeTooShort'],
      dayEventViolationError: ['TotalBreakTimeNotEnough'],
      filterMode: 'errors',
      events: [],
      days: [],
      violations: [],
      datesWithViolationsWarning: [],
      datesWithViolationsError: [],
      buttonState: {},
      total: 0,
      userdefindedStartTime: new DayPilot.Date(),
      startDate: undefined,
      endDate: '',
      navigatorConfig: {
        locale: "de-de",
        showMonths: 1,
        selectMode: "Week",
        startDate: new Date(),
        onBeforeCellRender: args => {
          const day = args.cell.day.toString('yyyy-MM-dd');
          if (this.startDate === undefined) {
            this.startDate = day;
          }

          if (this.datesWithViolationsError.includes(day)) {
            args.cell.cssClass = "navigator-day-violation-error";
          } else if (this.datesWithViolationsWarning.includes(day)) {
            args.cell.cssClass = "navigator-day-violation-warning";
          }
          this.endDate = day;
        },
        onVisibleRangeChanged: args => {
          this.startDate = formatDate(new Date(args.start));
          this.endDate = formatDate(new Date(args.end.addDays(-1)));
          this.loadEvents()
        },
        onTimeRangeSelected: args => {
          this.total = 0;
          this.calendar.startDate = args.start;
          this.calendar.update();
        }
      },
      config: {
        locale: "de-de",
        viewType: "Week",
        durationBarVisible: true,
        headerHeight: 75,
        cellHeight: 20,
        scale: "CellDuration",
        heightSpec: "BusinessHours",
        businessBeginsHour: 5,
        businessEndsHour: 22,
        onBeforeHeaderRender: args => {
          const date = args.header.start.toString("yyyy-MM-dd");
          const isEnabled = this.buttonState[date] || false;
          let minutes = this.getMinutes(args.header.start.value);
          args.header.html = `
                        <div class="${this.dayHasViolation(args.header.start.value)}">${args.header.start.toString("dd.MM.yyyy")}</div>
                        <div><button class="btn-update" ${isEnabled ? '' : 'disabled'} onclick="headerButtonClick('${args.header.start}')">Update</button></div>
                        <div>Summe: ${this.getTotalWorkTime(minutes)}</div>
                        `;

          this.total += minutes;

        },
        onBeforeEventRender: args => {
          args.data.moveHDisabled = true;
          args.data.resizeDisabled = true;
          args.data.cssClass = "event";
          var color = ColorHelper.getColor('regular');
          if (args.data.violationAsString.length > 0) {
            color = ColorHelper.getViolationColor(args.data.violationAsString);
          } else if (args.data.isBreak) {
            color = ColorHelper.getColor('break');
          }

          args.data.backColor = ColorHelper.lightenColor(color, 20);
          args.data.borderColor = color;
          args.data.barColor = color;
          args.data.barBackColor = ColorHelper.setTransparentColor("#FFFFFF", 0);
          args.data.toolTip = `
Dauer: ${args.data.durationInMinutes} Minuten\nStart: ${args.data.start.toString("dd.MM.yyyy HH:mm")}\nEnde: ${args.data.end.toString("dd.MM.yyyy HH:mm")}${args.data.violationAsString.length > 0 ? "\nVerstoß: " + this.getViolationMessage(args.data.violationAsString).title : ''}
          `;
        },
        onEventMove: (args) => {
          this.handleEventMove(args);
        },
      },
    }
  },
  components: {
    DayPilotCalendar,
    DayPilotNavigator
  },
  computed: {
    calendar() {
      return this.$refs.calendar.control;
    },
    navigator() {
      return this.$refs.navigator.control;
    },
    allViolations() {
      let violations = JSON.parse(JSON.stringify(this.violations))

      if (this.filterMode === 'errors') {
        violations = violations.filter(item =>
          ['BreakNotInValidTimeFrame', 'TotalBreakTimeNotEnough'].includes(item.violationAsString)
        );
      }
      violations = violations.sort((a, b) => {
        return new Date(a.start) - new Date(b.start);
      });

      return violations;
    },
  },
  methods: {
    loadEvents() {
      apiService.get(`/LegislativeWorktime/GetDays?filterStart=${this.startDate}&filterEnd=${this.endDate}`)
        .then(response => {
          const events = response.data.flatMap(day => {
            return day.items.map(item => {
              return {
                id: item.workItemId,
                start: item.startTimeCET,
                end: item.endTimeCET,
                html: "<a class='event-link' target='_blank' rel='noopener noreferrer' href='https://youtrack.incs.org/issue/" + item.issueIdLink + "'>" + item.issueSummary + "</a><br>" +
                  item.text,
                overlapping: false,
                isBreak: item.isBreak,
                issueSummary: item.issueSummary,
                durationInMinutes: item.durationInMinutes,
                violationAsString: item.violationAsString,
                violation: item.violation,
                isValidBreak: item.isValidBreak,
              };
            });
          });
          this.total = 0;
          this.events = events;
          this.days = response.data;
          this.violations = []
          this.datesWithViolationsError = [];
          this.datesWithViolationsWarning = [];

          this.days.forEach(day => {
            if (day.violationAsString.length > 0) {
              day.start = day.date;
              const eventDate = new DayPilot.Date(day.start).toString('yyyy-MM-dd');
              day.type = 'day';
              this.violations.push(day);

              if (this.dayEventViolationError.includes(day.violationAsString)) {
                this.datesWithViolationsError.push(eventDate);
              } else if (this.dayEventViolationWarning.includes(day.violationAsString)) {
                this.datesWithViolationsWarning.push(eventDate);
              }
            }
          });

          this.events.forEach(event => {
            if (event.violationAsString.length > 0) {
              const eventDate = new DayPilot.Date(event.start).toString('yyyy-MM-dd');
              event.type = 'item';
              this.violations.push(event);

              if (this.itemEventViolationError.includes(event.violationAsString)) {
                this.datesWithViolationsError.push(eventDate);
              } else if (this.itemEventViolationWarning.includes(event.violationAsString)) {
                this.datesWithViolationsWarning.push(eventDate);
              }
            }
          });
          this.calendar.update({ events });
          this.navigator.update({ events });
        })
        .catch(() => {
          console.log("GetDays Error!");
        })
        .finally(() => {
          console.log("GetDays Finally!");
        });
    },
    dayHasViolation(date) {
      let className = "";
      let violations = JSON.parse(JSON.stringify(this.violations));
      violations.forEach(violation => {
        if (violation.type == 'day' && date == violation.date) {
          if (violation.violationAsString == "TotalBreakTimeNotEnough") {
            return "error";
          } else {
            className = "warning";
          }
        }
      });
      return className;
    },
    getTotalWorkTime(minutes) {
      if (minutes == 0)
        return "-";

      return this.toHoursAndMinutes(minutes)
    },
    getMinutes(date) {
      let days = JSON.parse(JSON.stringify(this.days))

      let day = days.filter(e => new DayPilot.Date(e.date).getDatePart().toString('yyyy-MM-dd') == new DayPilot.Date(date).getDatePart().toString('yyyy-MM-dd'));
      if (day.length == 0)
        return 0;

      return day[0].totalWorkTime;
    },
    toHoursAndMinutes(totalMinutes) {
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    },

    switchView(input) {
      this.$refs.calendar.control.viewType = input;
      this.$refs.calendar.control.update();
      this.navigatorConfig.selectMode = input;
      this.$refs.navigator.control.update();
    },
    handleEventMove(args) {
      this.total = 0;

      let events = JSON.parse(JSON.stringify(this.events));

      const event = events.find(e => e.id == args.e.id());

      const newDate = new DayPilot.Date(args.newStart).getDatePart().toString('yyyy-MM-dd');

      if (event) {
        const oldDate = new DayPilot.Date(event.start).getDatePart().toString('yyyy-MM-dd');

        if (oldDate == newDate) {
          event.start = args.newStart;
          event.end = args.newEnd;
          this.buttonState[newDate] = true;
        }

        this.$refs.calendar.control.events.update(event);
      }

      this.$refs.calendar.control.update();
    },
    headerButtonClick(date) {
      this.total = 0
      const clickedDate = new DayPilot.Date(date).getDatePart();

      const eventsForDay = this.$refs.calendar.control.events.list.filter(event => {
        const eventDate = new DayPilot.Date(event.start).getDatePart();
        return eventDate.equals(clickedDate);
      }).sort((a, b) => {
        return new Date(a.start) - new Date(b.start);
      });

      if (eventsForDay.length === 0)
        return;

      apiService.post(`/LegislativeWorktime/UpdateDay`, {
        start: eventsForDay[0].start.toJSON(),
        newOrderedIds: eventsForDay.map(e => e.id)
      })
        .then(() => {
          this.loadEvents();

          Object.keys(this.buttonState).forEach(key => {
            this.buttonState[key] = false;
          });

        }).catch(() => {
          console.log("UpdateDay Error!");
        }).finally(() => {
          console.log("UpdateDay Finally!");

        })
    },
    getViolationMessage(type) {
      switch (type) {
        case "BreakNotInValidTimeFrameButAlreadyValidPause":
          return {
            title: "Pause zum falschen Zeitpunkt",
            desc: "Eine Pause muss spätestens nach sechs Stunden und darf erst 30min nach Arbeitsbeginn genommen werden. Nach der Pause müssen noch mind. 30min Arbeitszeit liegen."
          };
        case "WorkOnSundayOrHoliday":
          return {
            title: "Arbeit an einem Sonn- oder Feiertag",
            desc: "Es sollte i.d.R nicht an einem Sonn- oder Feiertag gearbeitet werden."
          };
        case "WorkDuringNightTime":
          return {
            title: "Nachtarbeit",
            desc: "Es sollte i.d.R. nicht Nachts zwischen 23:00 - 6:00 Uhr gearbeitet werden."
          };
        case "WorkDayLongerThan10H":
          return {
            title: "Zu lange gearbeitet",
            desc: "Die tägliche Arbeitszeit sollte i.d.R. <= 10h betragen."
          };
        case "DailyRestTimeTooShort":
          return {
            title: "Die Ruhezeit ist zu kurz",
            desc: "Die Ruhezeit zwischen zwei Arbeitstagen sollte i.d.R >= 11h sein."
          };
        case "BreakIsTooShort":
          return {
            title: "Pause nicht berücksichtigt",
            desc: "Eine Pause muss >= 15min lang sein damit sie angerechnet werden kann."
          };
        case "BreakNotInValidTimeFrame":
          return {
            title: "Pause zum falschen Zeitpunkt",
            desc: "Eine Pause muss spätestens nach sechs Stunden und darf erst 30min nach Arbeitsbeginn genommen werden. Nach der Pause müssen noch mind. 30min Arbeitszeit liegen."
          };
        case "TotalBreakTimeNotEnough":
          return {
            title: "Pause zu kurz",
            desc: "Die Pausenzeiten von 45min bei >= 9h Arbeit und 30min bei >= 6h Arbeit sollten i.d.R eingehalten werden."
          };
        case "AverageWorkDayLongerThan8H":
          return { title: "Zu lange gearbeitet", desc: "Die tägliche Arbeitszeit sollte i.d.R. 8h betragen." };
        default:
          break;
      }
    },
    filterViolations(mode) {
      this.filterMode = mode;
    },
    goToEventWeek(date) {
      const eventDate = new DayPilot.Date(date);

      // Get the start of the week (assuming Monday as the first day of the week)
      const dayOfWeek = eventDate.getDayOfWeek(); // Monday = 1, Sunday = 7
      const daysToSubtract = dayOfWeek - 1; // Adjusting to get to Monday
      const startOfWeek = eventDate.addDays(-daysToSubtract);

      // Update the calendar to show the week of the event
      this.$refs.calendar.control.startDate = startOfWeek;
      this.$refs.calendar.control.update();
      this.$refs.navigator.control.select(startOfWeek);

    },
    beautifulDate(dateString) {
      let date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${day}.${month}.${year}`;
    },
    beautifulTime(dateString) {
      let date = new Date(dateString);
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${hours}:${minutes}`;
    }
  },
  mounted() {
    if (localStorage.getItem("isLoggedIn") != "true") {
      this.$router.push('/');
      return;
    }

    this.loadEvents();
    window.headerButtonClick = this.headerButtonClick;
  }
}

function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

</script>
<style>
.tab-viewtype {
  display: flex;
  overflow: hidden;
  border: 1px solid #ccc;
  border-bottom: none;
  background-color: #f1f1f1;
}

.tab-viewtype button.tab-link {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  font-size: 14px;
  color: rgb(51, 51, 51);
}

.tab-viewtype button.tab-link:hover {
  background-color: #ddd;
}

.tab-viewtype button.tab-link.active {
  background-color: #ccc;
}

.tab-total {
  align-self: center;
  text-align: right;
  flex: 1;
  font-weight: bold;
  float: right;
  padding: 0 1rem;
  font-size: 14px;
}

.container-calendar {
  display: flex;
  gap: 8px;
  margin: 2rem 0;
}

.container-calendar hr {
  border-bottom: transparent;
  border-top: 1px solid #c0c0c0;
  margin: 0.5rem 0;
}

.container-calendar--buttons {
  display: flex;
  gap: 8px;
  align-items: center;
  font-size: 24px;
}

.calendar_default_event_inner {
  cursor: move !important;
  background: #2e78d6;
  color: #262626;
  border-radius: 5px;
  opacity: 0.9;
}

.calendar_default_colheader_inner {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.calendar_default_colheader_inner p {
  font-size: 18px;
}

.navigator-day-violation-warning {
  border-radius: 50px;
  background-color: #ffaf54;
}

.navigator-day-violation-error {
  border-radius: 50px;
  background-color: #ff727c;
}

.container-nav {
  display: flex;
  flex-direction: column;
}

.violation-container-header {
  display: flex;
  gap: 0.5rem;
  margin: 0.5rem 0;
}

.violation-container {
  height: 200px;
  flex-grow: 1;
  overflow-y: auto;
  
  /* border: 1px solid #c0c0c0; */
  /* padding: 0.125rem 0.25rem; */
}

.event-violation {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
  padding: 0.5rem;
  color: white;
  border-radius: 5px;
  font-size: 0.75rem;
  margin-bottom: 0.25rem;
  cursor: pointer;
}

.event-violation-info {
  border: 1px solid #adb5bd;
  background-color: #c1c6cb;
}

.event-violation-warning {
  border: 1px solid #fd7e14;
  background-color: #ffab65;
}

.event-violation-error {
  border: 1px solid #dc3545;
  background-color: #e35d6a;
}

.event-violation-date {
  margin-bottom: 0.25rem;
  font-weight: bold;
  cursor: pointer;
}

.event-violation-title {
  margin-bottom: 0.25rem;
  font-size: 0.8rem;
  font-weight: bold;
  cursor: pointer;
}

.event-violation-message {
  cursor: pointer;
}

.event-link {
  text-decoration: none;
  color: #323232;
  font-weight: bold;
  cursor: pointer;
}

#form_edit {
  display: flex;
  gap: 12px;
  justify-content: space-between;
  align-items: end;
  margin: 0 12px;
}

.btn-update {
  color: white;
  background-color: #4D4D4D;
  border: none;
  border-radius: 5px;
  padding: 0.25rem 0.5rem;
}

.btn-filter {
  color: white;
  background-color: #c0c0c0;
  border: none;
  border-radius: 5px;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
}

.btn-filter-selected {
  background-color: #4d4d4d;
}

.btn-update:hover:enabled {
  background-color: #c0c0c0;
  cursor: pointer;
}

.btn-update:disabled {
  background-color: #c0c0c0aa;
}

.btn-toggle-week {
  font-size: 24px;
  background-color: transparent;
  border: none;
}

.btn-toggle-week:hover {
  cursor: pointer;
}

a svg {
  fill: #4D4D4D;
  width: 18px;
}

a svg:hover {
  fill: black;
}

.error {
  color: #dc3545;
}

.warning {
  color: #fd7e14;
}

.calendar_default_main {
  height: 47.251rem;
}
</style>